import * as React from 'react'
import Important from '../icons/ui/Important'

const Error = () => (
  <div className='px2 py1 bg-red flex items-center col-12'>
    <Important className='col-1 mr2' />
    <span className='font-white h6'>Adding user was failed</span>
  </div>
)

export default Error



// WEBPACK FOOTER //
// ./src/components/membership-request/Error.tsx